export interface IUserInfoData{
    userId: number
    gender: number
    gold?:   number
    cards?:  number
    headImg: string
    ip?: string
    nickname: string
    tieCount?: number
    vipLevel?: number
    winCount?: number
    lostCount?: number
    breakRate?: number
}

export interface ISeatStateData {
    userInfo?: IUserInfoData
    playerId: number
    localPos: number
    remotePos: number
    isReady: boolean
    isOffLine: boolean
    isTmpLeave: boolean
    score: number
    isOwner: boolean
    reset()
}


export interface IRoomInfoData{
    roomId: number
    ruleTable: any
    playerCount: number
    roundCount: number
    curRoundNum: number
    mySeatInfo: ISeatStateData
    seatInfoList: ISeatStateData[]
    serverNowTimestamp: number
    timeOffset: number
    isGoldTable?: boolean
}

export class UserInfoData implements IUserInfoData{
    userId: number
    gender: number
    nickname: string
    headImg: string
    gold?:   number
    cards?:  number    
    ip?: string    
    tieCount?: number
    vipLevel?: number
    winCount?: number
    lostCount?: number
    breakRate?: number


    constructor(data){
        this.userId = data.userId
        this.nickname = data.nickname
        this.headImg = data.headImg
        this.gold = data.gold
        this.cards = data.cards
        this.ip = data.ip
        this.tieCount = data.tieCount
        this.winCount = data.winCount
        this.vipLevel = data.vipLevel
        this.lostCount = data.lostCount
        this.breakRate = data.breakRate
        this.gender = data.gender
    }
}